"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.tagStyles = exports.default = exports.TAG_TEXT = exports.TAG_SPACING = exports.TAG_SIZES = exports.TAG_COLORS = void 0;
var _core = require("@linaria/core");
var _intents = _interopRequireDefault(require("@ux/intents"));
const intents = new _intents.default();
const TAG_COLORS = exports.TAG_COLORS = {
  PRIMARY: 'tag-primary',
  PRIMARY_DARK_TEXT: 'tag-primary-dark-text',
  SECONDARY: 'tag-secondary',
  SUCCESS: 'tag-success',
  WARNING: 'tag-warning',
  DANGER: 'tag-danger',
  INFO: 'tag-info',
  HIGHLIGHT: 'tag-highlight',
  PURPLE: 'tag-purple',
  LIGHT_PURPLE: 'tag-light-purple',
  PURPLE_TEXT: 'tag-purple-text',
  LIGHT: 'tag-light',
  LIGHT_TEXT: 'tag-light-text',
  DARK: 'tag-dark',
  DARK_TEXT: 'tag-dark-text',
  TRANSPARENT: 'transparent'
};
const TAG_SIZES = exports.TAG_SIZES = {
  SMALL: 'tag-sm ms-1',
  MEDIUM: 'tag-md ms-2',
  LARGE: 'tag-lg ms-3',
  SMALL_NO_PADDING: 'tag-small-no-padding ms-2'
};
const TAG_SPACING = exports.TAG_SPACING = {
  DEFAULT: 'tag-spacing-default',
  TIGHT: 'tag-spacing-tight',
  WIDE: 'tag-spacing-wide',
  LEFT_ONLY: 'tag-spacing-left',
  NONE: 'tag-spacing-none'
};
const TAG_TEXT = exports.TAG_TEXT = {
  CAPITALIZE: 'tag-text-capitalize',
  NORMAL: 'tag-text-normal',
  BOLD: 'tag-text-bold',
  SEMIBOLD: 'tag-text-semibold',
  ELLIPSIS: 'tag-text-ellipsis',
  CENTER: 'tag-text-center',
  MUTED: 'tag-text-muted',
  RECOMMENDED: 'tag-recommended',
  EXACT_MATCH: 'tag-exact-match'
};
const TEXT_COLORS = {
  PURPLE: '#613EA3',
  WHITE: '#FFFFFF',
  LIGHT_PURPLE: 'var(--light-purple)',
  RECOMMENDED: '#823b25',
  EXACT_MATCH: intents.ux.feedbackHighContrastWarning.feedbackColor,
  AI_SPIN: intents.ux.box.outlineColor
};
const tagStyles = exports.tagStyles = "tsepgw3";
var _default = exports.default = tagStyles;